<div class="circle-tabs" [ngClass]="entity?.badgeConfig?.cssClass">
  <ul
    ngbNav
    (navChange)="onNavChange($event)"
    [activeId]="
      entity?.badgeConfig?.isClickable
        ? entity?.badgeConfig?.selectedBadge
        : null
    "
    #nav="ngbNav"
    class="nav nav-tabs row"
  >
    <li
      class="nav-item col-4 text-center nopadding"
      *ngFor="let item of entity?.tabs; let i = index"
    >
      <a
        [disabled]="!entity?.badgeConfig?.isClickable"
        [ngbNavItem]="i"
        class="nav-link"
        ngbNavLink
      >
        <div>
          <div class="row circle-loading" *ngIf="!item.isDataLoaded">
            <div class="col-4">
              <span
                class="animated-circle animation-circle-height d-block"
              ></span>
            </div>
          </div>
          <div class="number-circle" *ngIf="item.isDataLoaded">
            {{ item.badgeTitle }}
          </div>
          <h4 class="circle-label" *ngIf="item.isDataLoaded">
            {{ item.badgeLabel }}
          </h4>
        </div>
      </a>
    </li>
  </ul>
</div>
